import { InjectionToken } from "@angular/core";
import { Library } from '@library';


export const LIBRARY = new InjectionToken<Library>("LIBRARY");
